import PlantMilkProduct from 'models/PlantMilkProduct'

export const packagingInitialState = {
  category: PlantMilkProduct.category,
  subCategory: PlantMilkProduct.subCategory,
  MilkType: {
    value: PlantMilkProduct.MilkType,
    label: 'Plant-Based Milk Alternative Type',
  },
  OtherMilkType: PlantMilkProduct.OtherMilkType,
  Flavor: {
    value: PlantMilkProduct.Flavor,
    label: 'Flavor',
  },
  Type: {
    value: PlantMilkProduct.Type,
    label: 'Type',
  },
  Size: PlantMilkProduct.Size,
  Organic: PlantMilkProduct.Organic,
  MultiPackageType: PlantMilkProduct.MultiPackageType,
  MultiPackgeCount: PlantMilkProduct.MultiPackageCount,
}

export const milkTypeOptions = [
  {
    value: '',
    label: 'Plant-Based Milk Alternative Type',
    isDisabled: true,
  },
  {
    value: 'Almond Milk',
    label: 'Almond Milk',
  },
  { value: 'Cashew Milk', label: 'Cashew Milk' },
  { value: 'Coconut Milk', label: 'Coconut Milk' },
  { value: 'Oat Milk', label: 'Oat Milk' },
  { value: 'Pea Milk', label: 'Pea Milk' },
  { value: 'Rice Milk', label: 'Rice Milk' },
  { value: 'Soy Milk', label: 'Soy Milk' },
  { value: 'Other', label: 'Other' },
]
export const flavorOptions = [
  {
    value: '',
    label: 'Flavor',
    isDisabled: true,
  },
  {
    value: 'Original',
    label: 'Original',
  },
  { value: 'Plain', label: 'Plain' },
  { value: 'Regular', label: 'Regular' },
  { value: 'Vanilla', label: 'Vanilla' },
]

export const typeOptions = [
  {
    value: '',
    label: 'Type',
    isDisabled: true,
  },
  {
    value: 'Refrigerated',
    label: 'Refrigerated',
  },
  {
    value: 'Shelf-Stable',
    label: 'Shelf-Stable',
  },
]
